import {Model} from './model';
import {Unserializer} from './serialization';

export class EmailLog implements Model {
  emailLogId: number;
  emailStateId?: number;
  invoiceId?: number;
  userId: number;
  recipient: string;
  subject: string;
  message: string;
  invoiceAttachmentIds: number[];
  created: Date;

  static copy(oldObj: EmailLog): EmailLog {
    const newObj = new EmailLog();
    newObj.emailLogId = oldObj.emailLogId;
    newObj.emailStateId = oldObj.emailStateId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.userId = oldObj.userId;
    newObj.recipient = oldObj.recipient;
    newObj.subject = oldObj.subject;
    newObj.message = oldObj.message;
    newObj.invoiceAttachmentIds = oldObj.invoiceAttachmentIds;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.emailLogId;
  }

  isNew(): boolean {
    return isNaN(this.emailLogId);
  }

  clone(): EmailLog {
    return EmailLog.copy(this);
  }
}
